export class Change {
  constructor(public path: string, public newValue: any, public oldValue: any) {}
}
